import React from 'react'

import { Avatar } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'

import * as styles from './profile-avatar.module.css'

const LOGIN_AVATAR_SIZE = 40

interface ProfileAvatarProps {
  image?: string
  isAuthenticated: boolean
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ image, isAuthenticated }) =>
  isAuthenticated && image ? (
    <img className={styles.avatar} src={image} alt={name} />
  ) : (
    <SVG className={styles.svg} children={Avatar} size={LOGIN_AVATAR_SIZE} />
  )

export default ProfileAvatar
